<template>
<v-dialog v-model="active" persistent :width="400">
  <v-card>
    <v-card-title>
      <span class="headline">Login</span>
    </v-card-title>

    <v-spacer />

    <v-card-text>
      <v-form>
        <v-container>
          <v-text-field label="username" v-model="username" />
          <v-text-field
            v-model="password"
            type="password"
            label="password"
          />
          <v-alert
            v-for="error in errors" :key="error"
            type="error"
          >{{ error }}</v-alert>
        </v-container>
        <v-btn block color="primary" :loading="loading" @click="login">Login</v-btn>
      </v-form>
      <div class="text-justify">
        <small class="text-justify">
          FilmArch has been migrated. If you previously had an account, and still
          want to use the website send an email to enable your account:
        </small>
        <br/>
        <img src="/media/sendto.png" /> 
      </div>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: "LoginDialog",
  data() {
    return {
      active: false,
      resolve: null,
      username: "",
      password: "",
      errors: [],
      loading: false,
    }
  },
  inject: ["httpClient"],
  methods: {
    pop() {
      this.active = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
      })
    },
    login() {
      if (this.loading) return
      this.loading = true
      this.errors = []
      this.httpClient.login(this.username, this.password)
        .then(data => {
          const resolve = this.resolve
          this.resolve = null
          resolve(data)
          this.active = false
        }).catch(err => {
          console.log(err)
          if (err.response.status >= 400 && err.response.status < 500) {
            const errors = []
            if(err.response.data.detail) {
              errors.push(err.response.data.detail)
            }
            if (err.response.data.username) {
              err.response.data.username.forEach(
                err => errors.push(`username: ${err}`))
            }
            if (err.response.data.password) {
              err.response.data.password.forEach(
                err => errors.push(`password: ${err}`))
            }
            this.errors = errors
          }
        }).finally(() => this.loading = false)
    },
  },
}
</script>
